import { useCallback } from 'react';

export enum ImageModalV2Mode {
    VIEW = 'VIEW',
    CROP = 'CROP',
    BACKGROUND = 'BACKGROUND',
    DRAW = 'DRAW',
    UPLOAD = 'UPLOAD',
    DOWNLOAD = 'DOWNLOAD',
}

type UseImageModalV2ModeProps = {
    isEditable: boolean;
    isEditing: boolean;
    isEditingBackground: boolean;
    isEditingDrawing: boolean;
    isUploadingAttachment: boolean;
    isDownloadingAttachment: boolean;
    setRouteMode: (mode: ImageModalV2Mode) => void;
};

type UseImageModalV2ModeReturn = {
    mode: ImageModalV2Mode;
    setMode: (mode: ImageModalV2Mode) => void;
    isToolPanelOpen: boolean;
};

const getImageModalV2Mode = ({
    isEditable,
    isEditing,
    isEditingBackground,
    isEditingDrawing,
    isUploadingAttachment,
    isDownloadingAttachment,
}: UseImageModalV2ModeProps) => {
    if (!isEditable) return ImageModalV2Mode.VIEW;
    if (isEditing) return ImageModalV2Mode.CROP;
    if (isEditingBackground) return ImageModalV2Mode.BACKGROUND;
    if (isEditingDrawing) return ImageModalV2Mode.DRAW;
    if (isUploadingAttachment) return ImageModalV2Mode.UPLOAD;
    if (isDownloadingAttachment) return ImageModalV2Mode.DOWNLOAD;

    return ImageModalV2Mode.VIEW;
};

export const useImageModalV2Mode = (props: UseImageModalV2ModeProps): UseImageModalV2ModeReturn => {
    const { isEditable, setRouteMode } = props;
    const mode = getImageModalV2Mode(props);

    const setMode = useCallback(
        (newMode: ImageModalV2Mode) => {
            if (!isEditable) return;

            setRouteMode(newMode);
        },
        [isEditable, setRouteMode],
    );

    const isToolPanelOpen =
        mode === ImageModalV2Mode.CROP || mode === ImageModalV2Mode.BACKGROUND || mode === ImageModalV2Mode.DRAW;

    return { mode, setMode, isToolPanelOpen };
};
